import * as apiHelper from '../../apiHelper';
import * as constants from "./constants";
import * as blobHelper from '../../azureBlobHelper';

import { PAGE_ROUTES } from '../../constants/pageRoutes';

import { pushError, navigateTo, popError, setUserLoggedOut, pushSuccess } from '../global/actions';
import { getUserInfo } from '../dashboard/actions';

const controller = 'users';

export function getUserProfileInfo(id) {
  return (dispatch, getState) => {
    let state = getState();
    return apiHelper.apiGet(controller, state.Global.token, id)
      .then(response => response.json())
      .then(json => {
        if (!!json.user) {
          json.user.userId = json.user._id;
          dispatch(setUserProfileData(json.user))
        }
      });
  }

}

export function updateProfilePhoto(photo) {
  return (dispatch, getState) => {
    let state = getState();
    let user = state.User.user;
    let modifiedUser = {
      ...user,
      profile: {
        ...user.profile,
        photo: photo.name
      }
    }
    dispatch(setUserProfileData(modifiedUser));
    dispatch(updateUser(modifiedUser));
    dispatch(setUserProfilePhoto(photo));
    return blobHelper.createBlob(photo, user.userId);
  }
}

export function updateAboutMe(profile) {
  return (dispatch, getState) => {
    let state = getState();
    let user = state.User.user;
    let modifiedUser = {
      ...user,
      profile: {
        ...user.profile,
        about: profile.about,
        loyalties: profile.loyalties
      }
    }
    dispatch(setUserProfileData(modifiedUser));
    dispatch(updateUser(modifiedUser));
  }
}

export function updateUser(userToUpdate, updatingSelf = true) {
  return (dispatch, getState) => {
    let state = getState();
    let user = userToUpdate ? userToUpdate : state.User.profile;

    return apiHelper.apiPut(controller, user, state.Global.token, user._id)
      .then(response => response.json())
      .then(json => {
        if (json.error) { dispatch(pushError({ errType: "userupdate", error: json.error })) }
        if (updatingSelf)
          dispatch(getUserInfo(user._id));
      })
  }
}

export function resetPassword(data) {
  return (dispatch, getState) => {
    let state = getState();
    let error = {
      errType: "resetpassword",
      message: "Password could not be reset. A server error occurred."
    };
    dispatch(popError(error.errType));
    return apiHelper.apiPost('users', data, state.Global.token, "resetpassword")
      .then(response => {
        if (response.status >= 400) {
          const json = response.json();
          json.then(jsonData => {
            dispatch(pushError(jsonData.message ? jsonData.message : error))
          })
        } else {
          if (data.token || data.oldPassword) {
            const json = response.json();
            json.then(jsonData => {
              dispatch(pushSuccess(jsonData.message ? jsonData.message : "Password changed successfully"));

              setTimeout(() => {
                dispatch(setUserLoggedOut());
                dispatch(navigateTo(PAGE_ROUTES.LOGIN))
              }, 1000)

            })
          }
        }
      });

  }
}

export function addNewReview(userId, review, cb) {
  return (dispatch, getState) => {
    let state = getState();
    let global = state.Global;
    return apiHelper.apiPost(controller, review, global.token, userId, "reviews")
      .then(response => response.json())
      .then(json => { cb() })
  }
}

export function addResponseToReview(reviewId, response) {
  return (dispatch, getState) => {
    let state = getState();
    let review = state.User.user.reviews.filter(r => r._id === reviewId);
    if (!review.length)
      return null;
    review = review[0];
    review.response = response;
    return apiHelper.apiPut(controller, review, state.Global.token, state.User.user.userId, "reviews")
      .then(response => response.json())
      .then(json => { /* Review updated */ })
  }
}

export function addResponseToListingReview(reviewId, response) {
  return (dispatch, getState) => {
    let state = getState();
    let review = state.User.user.listingReviews.filter(r => r._id === reviewId);
    if (!review.length)
      return null;
    review = review[0];
    review.response = response;
    return apiHelper.apiPut('listing', review, state.Global.token, review.listingId, "reviews")
      .then(response => response.json())
      .then(json => { /* Review updated */ })
  }
}

export function syncBillingAddress(userId, blueSwipeUserId, userType) {
  return (dispatch, getState) => {
    let state = getState();
    return apiHelper.apiPost('blueswipe', { userId, userType }, state.Global.token, blueSwipeUserId, 'syncAddress')
  }
}

function setUserProfileData(userData) {
  return {
    type: constants.SET_PROFILE_DATA,
    data: userData
  }
}

function setUserProfilePhoto(photo) {
  return {
    type: constants.SET_PROFILE_PHOTO,
    data: photo
  }
}

export function getFavoriteListings(id) {
  return (dispatch, getState) => {
    return apiHelper.apiGet(controller, global.token, id, "favoriteListing")
      .then(response => response.json())
      .then(json => {
        dispatch(setFavoriteListings(json))
      });
  }
}

export function setFavoriteListings(data) {
  return {
    type: constants.SET_FAVORITE_LISTINGS,
    data: data
  }
}

export function isFavoriteListing(id, listingId) {
  return (dispatch, getState) => {
    return apiHelper.apiGet(controller, global.token, id, "favoriteListing")
      .then(response => response.json())
      .then(json => {
        const favorited = json.listings.some(el => el._id === listingId);
        dispatch(setFavoriteListing(favorited))
      });
  }
}

export function setFavoriteListing(data) {
  return {
    type: constants.SET_FAVORITE_LISTING,
    data: data
  }
}

export function addFavoriteListing(userId, listingId) {
  const data = {
    userId: userId,
    listingId: listingId
  }
  return (dispatch, getState) => {
    let state = getState();
    return apiHelper.apiPost('users', data, state.Global.token, "addFavoriteListing")
      .then(response => response.json())
      .then(json => {
        dispatch(isFavoriteListing(data.userId, data.listingId));
      });
  }
}


export function removeFavoriteListing(userId, listingId) {
  const data = {
    userId: userId,
    listingId: listingId
  }
  return (dispatch, getState) => {
    let state = getState();
    return apiHelper.apiPost('users', data, state.Global.token, "removeFavoriteListing")
      .then(response => response.json())
      .then(json => {
        dispatch(isFavoriteListing(data.userId, data.listingId));
      });
  }
}
